 <sol-modal
    *ngIf="initialized"
    (dismissed)="cancel()"
    (close)="cancel()"
    [title]="cvLocalizationService.getCachedText('Subscription_Modal', 'Subscription_Title', 'Subscription')"
    class="cxone-subscription-modal">

    <!-- Body -->
    <sol-modal-body>
        <!-- Loading Graphic -->
        <cv-loader [hidden]="!isLoading"></cv-loader>

        <!-- Frequency -->
        <div class="row title pt-3" cvLocalizedText langSection="Subscription_Modal" langKey="Recurrence">Recurrence</div>
        <br>
        <div class="row">
            <div class="col-6 label" cvLocalizedText langSection="Subscription_Modal" langKey="Frequency">FREQUENCY</div>
            <div class="col-6 label" *ngIf="selectedFrequency?.value === 1" cvLocalizedText langSection="Subscription_Modal" langKey="DOW">DAYS OF THE WEEK</div>
            <div class="col-6 label" *ngIf="selectedFrequency?.value === 2" cvLocalizedText langSection="Subscription_Modal" langKey="DOM">DAYS OF THE MONTH</div>
        </div>

        <div class="row">
            <div class="col-6">
                <sol-dropdown
                    *ngIf="initialized"
                    id="frequency-dropdown-menu"
                    [(ngModel)]="selectedFrequency"
                    (ngModelChange)="onFrequencyChange()"
                    [options]="frequencies"
                    [selection]="selectedFrequency"
                    [optionsValue]="'name'"
                    [optionsLabel]="'name'"
                    [required]="false"
                    [searchEnabled]="false"
                    ngDefaultControl>
                </sol-dropdown>
            </div>

            <!-- Daily -->
            <div class="col-6" *ngIf="selectedFrequency?.value === 0">
                <div class="row">
                    <div class="mr-2 pt-2" cvLocalizedText langSection="Subscription_Modal" langKey="Every">EVERY</div>
                    <sol-numeric-selector
                        *ngIf="initialized && schedule"
                        [(ngModel)]="schedule.repeatOptions.repeatValue"
                        [step]="1"
                        [min]="1"
                        [max]="99">
                    </sol-numeric-selector>
                    <div class="ml-2 pt-2" cvLocalizedText langSection="Subscription_Modal" langKey="Days">DAY(S)</div>
                </div>
            </div>

            <!-- Weekly -->
            <div class="col-6" *ngIf="selectedFrequency?.value === 1">
                <div class="row" *ngIf="initialized">
                    <sol-checkbox class="col-3"
                        *ngFor="let day of daysOfWeek"
                        [(ngModel)]="day.selected"
                        (ngModelChange)="onSelectedDaysChange()">
                        <span>{{day.shortName}}</span>
                    </sol-checkbox>
                </div>
            </div>

            <!-- Monthly -->
            <div class="col-6" *ngIf="selectedFrequency?.value === 2">
                <sol-dropdown 
                    *ngIf="initialized"
                    [isMultiple]="true"
                    [(ngModel)]="daysOfMonthSelected"
                    [placeholder]="monthlyPlaceholder"
                    [options]="daysOfMonth"
                    [optionsLabel]="'name'"
                    (ngModelChange)="onChangeSelectedDOM()"
                    ngDefaultControl>
                </sol-dropdown>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-6 label" cvLocalizedText langSection="Subscription_Modal" langKey="At">AT</div>
        </div>
        <div class="row">
            <!-- Time Picker -->
            <!-- TODO: Refactor sol-dropdown used as time picker to use a shared component -->
            <div class="time-picker col-6">
                 <sol-dropdown
                    [(ngModel)]="selectedTime"
                    [options]="timePickerOptions"
                    [isMultiple]="false"
                    [searchEnabled]="false"
                    optionsLabel="label"
                    optionsValue="value"
                    (selectionChange)="onTimePickerChange()"
                    [showFooter]="false"
                    ngDefaultControl>
                </sol-dropdown>
            </div>
            <!-- Repeat Hourly Checkbox -->
            <sol-checkbox 
                *ngIf="initialized"
                class="col-6 align-self-center"
                [hidden]="selectedFrequency?.value === 0"
                [(ngModel)]="repeatHourlySelected"
                (ngModelChange)="onRepeatHourlyChanged()"
                >
                <span style="text-transform: none;">{{getRepeatHourlyText()}}</span>
            </sol-checkbox>
        </div>
        <br>
        <div class="row title" cvLocalizedText langSection="Subscription_Modal" langKey="Recipients">Recipients</div>
        <br>
        <div class="row">
            <div class="col-6">
                <sol-checkbox
                    *ngIf="initialized && schedule"
                    [ngClass]="{'disabled': !ownerUUID}"
                    [(ngModel)]="schedule.sendToMe">
                    <span style="text-transform: none;">{{getSendToMeText()}}</span>
                </sol-checkbox>
            </div>
        </div>
        <br>
        <!-- Frequency End -->
        <!-- Emails -->
        <div class="row">
            <div class="col-6 label" cvLocalizedText langSection="Subscription_Modal" langKey="Emails">EMAIL ADDRESSES</div>
        </div>
        <div class="row">
            <div class="col-12 recipients-dropdown">
                <sol-dropdown 
                    *ngIf="initialized"
                    [isMultiple]="true"
                    [searchEnabled]="true"
                    [options]="subscriptionRecipientOptions"
                    [selection]="selectedRecipients"
                    [disabled]="shouldDisableEmailOptions"
                    [optionsLabel]="'name'"
                    [optionsValue]="'value'"
                    [optionTemplate]="optionTemplate"
                    [placeholder]="emailPlaceholder"
                    [selectedOptionTemplate]="selectedOptionTemplate"
                    (selectionChange)="onRecipientSelectionChange($event)"
                    >
                </sol-dropdown>
                <ng-template #optionTemplate let-optionScope="optionScope">
                <div style="display: flex; flex-direction: column;">
                    <span style="vertical-align: middle" class="subscription-username-text"> {{optionScope.projectedData.primaryText}} </span>
                    <span style="vertical-align: middle" class="subscription-email-text"> {{optionScope.projectedData.secondaryText}} </span>
                </div>
                </ng-template>
                <ng-template #selectedOptionTemplate let-placeholderValue="placeholderValue">
                    <span style="vertical-align: middle">{{ placeholderValue.displayText }}</span>
                </ng-template>
                <div class="recipients-loader" *ngIf="isEmailOptionsLoading">
                    <cv-loader
                        [loaderType]="'cxone'"
                        size="large"
                        [overlay]="false">
                    </cv-loader>
                </div>
            </div>
        </div>
        <br>
        <!-- Emails End -->
    </sol-modal-body>
    <!-- Body End -->

    <!-- Footer -->
    <sol-modal-footer>
        <button type="button" class="btn btn-text mr-2" (click)="cancel()" cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</button>
        <button 
            type="button" 
            class="btn btn-primary" 
            [disabled]="(!schedule?.sendToMe && selectedRecipients.length === 0) || (this.selectedFrequency?.value === 1 && checkSelectedWeeks()) || (this.selectedFrequency?.value === 2 && this.daysOfMonthSelected.length === 0) || (schedule?.subscriptionId && !isDirty)" 
            (click)="save()" 
            cvLocalizedText langSection="Common" langKey="Subscribe">Subscribe</button>
    </sol-modal-footer>
    <!-- Footer End -->

</sol-modal>
